"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearBountyPostsRoutine = exports.getBountyPostsRoutine = void 0;
var redux_saga_routines_1 = require("redux-saga-routines");
// creating routine
exports.getBountyPostsRoutine = (0, redux_saga_routines_1.createRoutine)('bounty/GET_POSTS');
// export const mapPostsInfoRoutine = createRoutine("feed/MAP_POSTS_INFO");
exports.clearBountyPostsRoutine = (0, redux_saga_routines_1.createRoutine)('bounty/CLEAR_POSTS');
